export enum KgType {
  LAKE = 'Lake',
  FISHING_AREA = 'FishingArea',
  WATER_ACCESS = 'WaterAccessSite',
  FISHING_REGION = 'FishingRegion',
}
